import { Injector } from '@angular/core';

export class LibraryInjector {
  private static injector: Injector;

  static setInjector(injector: Injector): void {
    this.injector = injector;
  }

  static getInjector(): Injector {
    if (!this.injector) {
      throw new Error(
        'LibraryInjector is not set. Make sure to set it in your app module.'
      );
    }
    return this.injector;
  }
}
